const checkHeight = (callback) => {
  if (window.innerHeight >= document.querySelector('.root').offsetHeight) callback();
};

export default checkHeight;
